import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=792adf30&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('792adf30')) {
      api.createRecord('792adf30', component.options)
    } else {
      api.reload('792adf30', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=792adf30&", function () {
      api.rerender('792adf30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YoILXyPla7QI/JS/comp/pricelist.vue"
export default component.exports